import useOutsideClick from '../../../hooks/useClickOutside';
import { useEffect, useRef, useState } from 'react';
import { OrderInputWrapper } from './OrderInput.style';
import Icon from '../Icon';

interface IOrderInput {
    label: string;
    onOrder?: (value: string, label: string) => void;
}

export default function OrderInput({ label, onOrder }: IOrderInput) {
    const [order, setOrder] = useState('');
    const [clickOutside, setClickOutside] = useState(false);
    const ref = useRef<HTMLInputElement | null>(null);

    const handleOrder = (value: string) => () => {
        order === value ? setOrder('') : setOrder(value);
    };

    useOutsideClick(ref, () => {
        if (order) {
            setOrder('');
            setClickOutside(true);
        }
    });

    useEffect(() => {
        if (!clickOutside || order) {
            onOrder && onOrder(order, label);
            setClickOutside(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order]);

    return (
        <OrderInputWrapper ref={ref}>
            <p className={`order__title ${order && 'active'}`} onClick={handleOrder(order === 'asc' ? 'desc' : 'asc')}>
                {label}
            </p>
            {false && (
                <div className="order__buttons_container">
                    <Icon
                        disableFill
                        className={`order__buttons_icon ${order === 'asc' && 'active'}`}
                        icon="pcom-icon-chevron-up"
                        size={8}
                        onClick={handleOrder('asc')}
                        data-id="asc-button"
                    />
                    <Icon
                        disableFill
                        className={`order__buttons_icon ${order === 'desc' && 'active'}`}
                        icon="pcom-icon-chevron-down"
                        size={8}
                        onClick={handleOrder('desc')}
                        data-id="desc-button"
                    />
                </div>
            )}
        </OrderInputWrapper>
    );
}
